module.exports = __webpack_public_path__ + "img/sm-x.e14bc2f3.svg";